import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.array.for-each";
import { useEffect, useLayoutEffect, useRef, useDebugValue } from 'react';
var isClient = typeof window !== 'undefined' && !/ServerSideRendering/.test(window.navigator && window.navigator.userAgent);
export var useIsomorphicLayoutEffect = isClient ? useLayoutEffect : useEffect;

var affectedToPathList = function affectedToPathList(state, affected) {
  var list = [];

  var walk = function walk(obj, path) {
    var used = affected.get(obj);

    if (used) {
      used.forEach(function (key) {
        walk(obj[key], path ? [].concat(_toConsumableArray(path), [key]) : [key]);
      });
    } else if (path) {
      list.push(path);
    }
  };

  walk(state);
  return list;
};

export var useAffectedDebugValue = function useAffectedDebugValue(state, affected) {
  var pathList = useRef(null);
  useEffect(function () {
    pathList.current = affectedToPathList(state, affected);
  });
  useDebugValue(pathList.current);
};